<template>
    <div class="mt-4 mb-2" style="background-color: rgb(255, 255, 255);">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <div v-if="!loading">
            <div class="pa-3" v-if="!communications.length">
                No other communications from this account.
            </div>
            <div
                class=""
                v-if="communications.length"
                v-for="(communication, index) in communications"
            >
                <div class="layout row mb-2 px-3">
                    <!-- <v-icon class="mr-2" dark :color="getStatusIconColor(call)">{{
                    getStatusIcon(call)
                }}</v-icon> -->
                    <div
                        v-bind:class="{
                            'callback-request-status-pending':
                                communication.status == 'PENDING',
                            'callback-request-status-completed':
                                communication.status != 'PENDING',
                        }"
                        class="mr-2 px-2"
                        style="color: #fff; padding-top: 1px; padding-bottom: 3px;"
                    >
                        {{ communication.status }}
                    </div>
                </div>
                <div class="layout row wrap mb-2 px-3">
                    <div class="width-200 font-weight-medium">Date:</div>
                    <div>{{ communication.dateTime | time }}</div>
                </div>
                <div class="layout row wrap mb-2 px-3">
                    <div class="width-200 font-weight-medium">Type:</div>
                    <div>{{ communication.type }}</div>
                </div>
                <div class="layout row wrap mb-2 px-3">
                    <div class="width-200 font-weight-medium">By User:</div>
                    <div>{{ communication.assignedTo }}</div>
                </div>
                <div
                    class="layout row wrap mb-2 px-3"
                    v-if="communication.completedAt"
                >
                    <div class="width-200 font-weight-medium">
                        Completed At:
                    </div>
                    <div>{{ communication.completedAt | time }}</div>
                </div>
                <div
                    class="layout row wrap mb-2 px-3"
                    v-if="communication.direction"
                >
                    <div class="width-200 font-weight-medium">Direction:</div>
                    <div>{{ communication.direction }}</div>
                </div>
                <div
                    class="layout row wrap mb-2 px-3"
                    v-if="communication.note"
                >
                    <div class="width-200 font-weight-medium">Note:</div>
                    <div>{{ communication.note }}</div>
                </div>
                <div
                    class="layout row wrap mb-2 px-3"
                    v-if="communication.text"
                    style="white-space: normal; width: 500px;"
                >
                    <div class="width-200 font-weight-medium">Text:</div>
                    <div>{{ communication.text }}</div>
                </div>
                <v-divider
                    class="py-2 mb-1"
                    v-if="index + 1 < communications.length"
                ></v-divider>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            communications: [],
            loading: true,
        };
    },
    async created() {
        await this.loadCommunications();
    },
    computed: {},
    methods: {
        async loadCommunications() {
            const communications = await this.$http.get(
                "api/communications/getForAccount?accountID=" +
                    this.row.accountID
            );

            this.communications = communications.filter(
                (c) => c.callbackRequestID != this.row.callbackRequestID
            );

            this.loading = false;
        },
        getStatusIcon(call) {
            switch (call.status) {
                case "COMPLETED":
                    return "mdi-check-circle";
                default:
                    return "mdi-clock";
            }
        },
        getStatusIconColor(call) {
            switch (call.status) {
                case "COMPLETED":
                    return "success";
                default:
                    return "#fdb400";
            }
        },
    },
};
</script>
<style>
.other-calls-detail-text {
    font-size: 16px;
    font-weight: 400;
}
.callback-request-status-pending {
    background-color: #fdb400;
}
.callback-request-status-completed {
    background-color: #4caf50;
}
</style>
